var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8308 4.94293L12.4908 1.98293C11.3508 1.34293 9.49078 1.34293 8.34078 1.98293L3.00078 4.94293C1.79078 5.61293 0.800781 7.29293 0.800781 8.67293V14.3229C0.800781 15.7029 1.79078 17.3829 3.00078 18.0529C4.79078 19.0429 6.55078 20.1829 8.41078 21.0229C9.67078 21.5929 11.2408 21.7129 12.4908 21.0229L17.8308 18.0529C19.0408 17.3829 20.0308 15.7029 20.0308 14.3229V8.67293C20.0308 7.29293 19.0408 5.61293 17.8308 4.94293Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4111 20.5729V11.5029",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2113 6.39307L10.3813 11.5031L1.61133 6.42307",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00102 15.9827L3.54102 14.5127L5.01102 14.0527",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93137 16.8025L3.65137 14.5825",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidthIcon);
export default __webpack_public_path__ + "static/media/width-icon.774cda0bc79828c335c00adf75b18680.svg";
export { ForwardRef as ReactComponent };